import { handleActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = null

export default handleActions(
  {
    [rawActions.setDeleteSessionFolderId](state, action) {
      return action.payload
    },
    [rawActions.clearDeleteSessionFolderId](state, action) {
      return null
    },
    [rawActions.resetGalleryState](state, action) {
      return defaultState
    },
  },
  defaultState
)
